<template>
  <component :is="productTileComponent" v-bind="$props"></component>
</template>

<script>
import ProductTileB from './ProductTileB.vue';
import ProductTileSimple from './ProductTileSimple.vue';
import ProductTileWidget from './ProductTileWidget.vue';


export default {
  name: 'ProductTile',
  components: {
    ProductTileB,
    ProductTileSimple,
    ProductTileWidget
  },
  props: {
    textAlignment: String,
    simple: Boolean,
    widget: Boolean,
    collection: Boolean,
    product: Object,
    selectedVariant: Object,
    onAddToCart: Function, // if not provided, the atc will not show
    collectionHandle: String, // used for linking to pdp with proper collection
    collectionGender: String, // used for linking to pdp for unisex products
    showWishlist: Boolean,
    enableSimpleTileCta: {
      type: Boolean,
      default: false,
    },
    showMobileATC: {
      type: Boolean,
      default: true,
    }, // show ATC buttons on hover
    truncateTitle: {
      type: Boolean,
      default: true,
    },
    fullTileClick: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    productTileComponent() {
      if (!this.simple && !this.widget) return 'ProductTileB';
      if (this.simple) return 'ProductTileSimple';
      if (this.widget) return 'ProductTileWidget';
    },
  },
};
</script>
